import { render, staticRenderFns } from "./MBListingContainer.vue?vue&type=template&id=2cd52bd4"
import script from "./MBListingContainer.vue?vue&type=script&lang=js"
export * from "./MBListingContainer.vue?vue&type=script&lang=js"
import style0 from "./MBListingContainer.vue?vue&type=style&index=0&id=2cd52bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports